<button mat-raised-button (click)="selectUploadFile()">
  <mat-icon [inline]="true" style="font-size: 17px">arrow_upward</mat-icon>
  {{ "utils.buttons.upload" | translate }}
</button>
